<cw-datepicker
  class="date-picker"
  customShadowCss
  styles=".calendar-panel{position: fixed!important;}"
  [mode]="mode()"
  [attr.data-vef]="attrVef()"
  [status]="error() ? 'error' : null"
  [assistiveText]="error()"
  [label]="label()"
  [required]="required()"
  [disabled]="disabled()"
  [readonly]="readonly()"
  [placeholder]="placeholder()"
  [enableTime]="enableTime() || timeOnly()"
  [value]="value()"
  [locale]="locale()"
  [dateFormat]="dateFormat()"
  (dateChange)="selected($event.detail)"
/>
